import React from 'react';
import './TicketReceiptModal.css';

// Codes produit "mariage" (payant MAR=40, gratuit Marriage Gratis=44) — affiches en
// "AAxBB" au lieu de "AABB" pour ne pas les confondre visuellement avec un numero
// Lotto 4C (41/42/43), qui a aussi 4 chiffres mais reste un numero simple.
const MARRIAGE_PRODUCT_CODES = [40, 44];

const formatNumero = (line) => {
  if (MARRIAGE_PRODUCT_CODES.includes(line.product_code) && line.numbers.length === 4) {
    return `${line.numbers.slice(0, 2)}x${line.numbers.slice(2)}`;
  }
  return line.numbers;
};

const TicketReceiptModal = ({
  ticket, bank, bankName, onClose,
  onConfirm, confirmLabel, confirmHint, confirming,
}) => {
  const created = new Date(ticket.created_at);
  const total = ticket.lines.reduce((s, l) => s + Number(l.amount), 0);

  return (
    <div className="trm-overlay">
      <div className="trm-modal">
        <div className="trm-header">
          <span className="trm-title">Ticket</span>
          <button className="trm-close-btn" onClick={onClose}></button>
        </div>

        <div className="trm-body">
          <div className="trm-bank-box">
            <strong>Banque:</strong> {bank} - {bankName}
          </div>

          <div className="trm-info-grid">
            <span><strong>Date:</strong> {created.toLocaleDateString()}</span>
            <span><strong>Utilisateur:</strong> {ticket.device_serial || '—'}</span>
            <span><strong>Type de Doc.:</strong> {ticket.was_offline ? 'L' : 'O'}</span>
            <span><strong>Temp:</strong> {created.toLocaleTimeString()}</span>
            <span><strong>Sequence:</strong> {ticket.sq ?? '—'}</span>
            <span><strong>Annule?:</strong> {ticket.is_deleted ? 'Oui' : 'No'}</span>
            <span><strong>Serial:</strong> {ticket.serial || '—'}</span>
            <span>
              <strong>Paye?:</strong> {ticket.is_paid ? 'Oui' : 'No'}
              {ticket.is_paid && ticket.paid_at && (
                <> ({new Date(ticket.paid_at).toLocaleString()})</>
              )}
            </span>
          </div>

          <div className="trm-divider" />

          <div className="trm-tags-row">
            <span className="trm-tag">
              <span className="trm-tag-label">Loterie:</span> {ticket.tirage_code}|{ticket.tirage_name}
            </span>
            <span className="trm-tag trm-tag-narrow">
              <span className="trm-tag-label">Ticket:</span> {ticket.no ?? '—'}
            </span>
          </div>

          <table className="trm-table">
            <thead>
              <tr>
                <th>Numero</th>
                <th>Points</th>
                <th>Montant</th>
              </tr>
            </thead>
            <tbody>
              {ticket.lines.map((line) => (
                <tr key={line.id}>
                  <td>{formatNumero(line)}</td>
                  <td>{Math.round(Number(line.amount))}</td>
                  <td className="trm-amount">${Number(line.amount).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="trm-total-bar">Total: ${total.toFixed(2)}</div>

          {onConfirm && confirmHint && <p className="trm-confirm-hint">{confirmHint}</p>}
        </div>

        <div className="trm-footer">
          <button className="trm-close-action" onClick={onClose}>Cerrar</button>
          <button className="trm-print-action" onClick={() => window.print()}>Imprimir</button>
          {onConfirm && (
            <button className="trm-confirm-action" onClick={onConfirm} disabled={confirming}>
              {confirming ? '...' : (confirmLabel || 'Confirmer')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketReceiptModal;
